export const USER_IDLE = 'USER_IDLE';

export const setUserIdle = () => {
    return {
        type: USER_IDLE,
    }
};



// WEBPACK FOOTER //
// ./src/actions/IdleActions.js